<template>
    <div>
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/home' }"
                >首页</el-breadcrumb-item
            >
            <el-breadcrumb-item>产品管理</el-breadcrumb-item>
            <el-breadcrumb-item>订单管理</el-breadcrumb-item>
            <el-breadcrumb-item>退费管理</el-breadcrumb-item>
            <el-breadcrumb-item>退费详情</el-breadcrumb-item>
        </el-breadcrumb>
        <el-page-header @back="goBack"></el-page-header>
        <el-card style="margin-top: 15px">
            <el-descriptions title="退费订单详情" border>
                <el-descriptions-item label="赛季">{{ orderDetailForm.season }}</el-descriptions-item>
                <el-descriptions-item label="订单名称">
                  {{ orderDetailForm.orderName }}
                  <el-link type="primary" v-if="orderDetailForm.tbOrderProduct" @click="detail = true">详情</el-link>
                </el-descriptions-item>
                <el-descriptions-item label="订单号">{{ orderDetailForm.orderNo }}</el-descriptions-item>
                <el-descriptions-item label="账号">{{ orderDetailForm.phone }}</el-descriptions-item>
                <el-descriptions-item label="姓名">{{ orderDetailForm.userName }}</el-descriptions-item>
                <el-descriptions-item label="学校">{{ orderDetailForm.schoolName }}</el-descriptions-item>
                <el-descriptions-item label="年级">{{ gradeStr(orderDetailForm.grade) }}</el-descriptions-item>
                <el-descriptions-item label="订单金额">¥{{ orderDetailForm.orderMoney }}</el-descriptions-item>
                <el-descriptions-item label="支付金额">¥{{ orderDetailForm.orderPayMoney }}</el-descriptions-item>
                <el-descriptions-item label="退款金额">¥{{ orderDetailForm.refundMoney }}</el-descriptions-item>
                <el-descriptions-item label="优惠券">{{ tbOrderCoupon ? tbOrderCoupon.couponName : '未使用' }}</el-descriptions-item>
                <el-descriptions-item label="优惠券金额">{{ tbOrderCoupon ? ('¥' + tbOrderCoupon.discountAmount) : '--' }}</el-descriptions-item>
                <el-descriptions-item label="购买时间">{{ orderDetailForm.orderPayTime }}</el-descriptions-item>
                <el-descriptions-item label="申请时间">{{ orderDetailForm.createTime }}</el-descriptions-item>
                <el-descriptions-item label="订单状态">
                  <el-tag :type="getStatus()">{{ getStatusLabel() }}</el-tag>
                </el-descriptions-item>
                <el-descriptions-item label="退款类型">{{ orderDetailForm.applyStatus === 0 ? '仅退款' : '退货退款' }}</el-descriptions-item>
                <el-descriptions-item label="货物状态">{{ orderDetailForm.applyType === 1 ? '未收到货' : '已收到货' }}</el-descriptions-item>
                <el-descriptions-item label="申请原因">{{ orderDetailForm.reason }}</el-descriptions-item>
            </el-descriptions>
        </el-card>
        <el-card style="margin-top: 15px">
            <el-row class="title_row">
                <el-col>
                    <span class="title_class">退费审批详情</span>
                </el-col>
            </el-row>
            <el-table
                header-cell-class-name="tableHeaderStyle"
                :data="applyList"
                border
                stripe
            >
                <el-table-column label="#" type="index"></el-table-column>
                <el-table-column
                    label="审批部门"
                    prop="levelName"
                    width="150px"
                ></el-table-column>
                <el-table-column
                    label="审批人"
                    prop="userName"
                    width="150px"
                ></el-table-column>
                <el-table-column label="审批状态" prop="result" width="100px">
                    <template slot-scope="scope">
                        <el-tag
                            v-if="scope.row.result === -1"
                            type="warning"
                            size="mini"
                            >未审批</el-tag
                        >
                        <el-tag
                            v-else-if="scope.row.result === 1"
                            type="success"
                            size="mini"
                            >审批通过</el-tag
                        >
                        <el-tag
                            v-else-if="scope.row.result === 2"
                            type="danger"
                            size="mini"
                            >审批未通过</el-tag
                        >
                        <span v-else>未知</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="审批时间"
                    prop="reviewDate"
                    width="200px"
                ></el-table-column>
                <el-table-column
                    label="审批意见"
                    prop="message"
                ></el-table-column>
                <el-table-column label="操作" width="150px">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            icon="el-icon-s-check"
                            size="small"
                            :disabled="!scope.row.resulting"
                            @click="showApprovalDialog(scope.row)"
                            >审批</el-button
                        >
                        <el-button
                            type="text"
                            icon="el-icon-edit"
                            size="small"
                            :disabled="!scope.row.resulting"
                            @click="showChangePriceDialog(scope.row)"
                            >价格修改</el-button
                        >
                    </template>
                </el-table-column>
            </el-table>
        </el-card>
        <el-dialog
            title="处理审批"
            :visible.sync="approvalDialogVisible"
            width="40%"
        >
            <div>
                审批意见:
                <el-input
                    type="textarea"
                    v-model="approvalMessage"
                    style="margin-top: 15px"
                ></el-input>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="approval(1)" type="success">同 意</el-button>
                <el-button @click="approval(2)" type="danger">驳 回</el-button>
                <el-button @click="approvalDialogVisible = false"
                    >取 消</el-button
                >
            </div>
        </el-dialog>
        <el-dialog
            title="修改退款价格"
            :visible.sync="changePriceDialogVisible"
            width="40%"
            @close="orderPriceDialogClose"
        >
            <el-form
                :model="orderPriceModel"
                label-width="140px"
                ref="orderPriceModelFormRef"
                :rules="orderPriceModelRules"
                style="width: 100%"
            >
                <el-row>
                    <el-col :span="20">
                        <el-form-item label="退款金额" prop="refundMoney">
                            <el-input
                                v-model="orderPriceModel.refundMoney"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="20">
                        <el-form-item label="修改原因" prop="message">
                            <el-input
                                v-model="orderPriceModel.message"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="changeOrderPrice" type="success"
                    >确 定</el-button
                >
                <el-button @click="changePriceDialogVisible = false"
                    >取 消</el-button
                >
            </div>
        </el-dialog>
        <el-dialog
            title="产品详情"
            :visible.sync="detail"
            width="600px"
            @close="detail = false"
        >
          <div class="flex" v-for="(item, i) in orderDetailForm.tbOrderProduct" :key="i">
            <div>{{ item.productName }}</div>
            <div>¥{{ item.discountAmount }}</div>
          </div>
        </el-dialog>
    </div>
</template>

<script>
import { refundRecordInfo, getSysUserInfo, refundRecordReview, changeOrderPrice } from '@/http/api'
export default {
  data () {
    return {
      dict_refundState: this.$userInfo.dict_refundState(),
      orderPriceModelRules: {
        refundMoney: [{ required: true, message: '请输入', trigger: 'blur' }],
        message: [{ required: true, message: '请输入', trigger: 'blur' }]
      },
      dict_grade: this.$userInfo.getGradeData(),
      changePriceDialogVisible: false,
      orderDetailForm: {},
      tbOrderCoupon: {},
      refundId: this.$route.query.refundId,
      applyList: [],
      approvalDialogVisible: false,
      approvalMessage: '',
      approvalData: {},
      orderPriceModel: {
        message: '',
        refundMoney: null
      },
      level: 0,
      message: '', // 价格修改处理意见
      detail: false
    }
  },
  created () {
    this.getOrderDetail()
    // this.getApplyList()
  },
  methods: {
    goBack () {
      this.$router.back()
    },
    getOrderDetail () {
      refundRecordInfo({ id: this.refundId }).then((res) => {
        if (res.code === 200) {
          this.orderDetailFormData = res.data
          this.tbOrderCoupon = res.data.tbOrderCoupon
          if (res.data.refundProcessRecords) {
            this.applyList = res.data.refundProcessRecords
          }
          this.getUserInfo(res.data.userId)
        } else {
          return this.$message.error(res.msg)
        }
      }).catch((err) => {
        console.log('err', err)
      })
    },
    // 获取用户信息
    getUserInfo (userId) {
      getSysUserInfo({ userId: userId }).then((res) => {
        console.log('getSysUserInfo', res)
        this.orderDetailFormData.schoolName = res.data.schoolName
        this.orderDetailFormData.grade = res.data.grade
        this.orderDetailForm = this.orderDetailFormData
      }).catch((err) => {
        console.log('返回的err', err)
      })
    },
    showApprovalDialog (item) {
      this.approvalData = {
        refundRecordId: this.orderDetailFormData.id
      }
      this.approvalMessage = '同意'
      this.level = item.level
      this.message = item.message
      this.approvalDialogVisible = true
    },
    showChangePriceDialog (rowData) {
      this.orderPriceModel.refundProcessRecordId = rowData.id
      this.changePriceDialogVisible = true
    },
    orderPriceDialogClose () {
      this.$refs.orderPriceModelFormRef.resetFields()
    },
    changeOrderPrice () {
      this.$refs.orderPriceModelFormRef.validate(async valid => {
        if (!valid) return
        changeOrderPrice(this.orderPriceModel).then((res) => {
          if (res.code === 200) {
            this.changePriceDialogVisible = false
            this.$message.success('修改成功')
            this.getOrderDetail()
          } else {
            this.$message.error(res.msg)
          }
        }).catch((err) => {
          console.log('返回的err', err)
        })
      })
    },
    getStatusLabel () {
      return this.dict_refundState.find(item => item.dictCode === Number(this.$route.query.status)).dictLabel
    },
    getStatus () {
      return this.dict_refundState.find(item => item.dictCode === Number(this.$route.query.status)).statusType
    },
    approval (flag) {
      if (flag === 2) {
        if (this.approvalMessage === '') {
          return this.$message.warning('请输入审批意见')
        }
        if (this.approvalMessage === '同意') {
          this.approvalMessage = ''
          return this.$message.warning('请输入审批意见')
        }
      } else {
        if (this.approvalMessage === '') {
          this.approvalMessage = '同意'
        }
      }
      if (this.approvalMessage) {
        this.approvalData.refuseReason = this.message ? `${this.message}；审批${flag === 1 ? '通过' : '未通过'}，原因：${this.approvalMessage}` : this.approvalMessage
      } else {
        this.approvalData.refuseReason = this.message
      }
      this.approvalData.status = flag
      this.approvalData.level = this.level
      refundRecordReview(this.approvalData).then((res) => {
        if (res.code === 200) {
          this.$message.success('审批成功')
          this.approvalDialogVisible = false
          this.getOrderDetail()
        }
      }).catch((err) => {
        console.log('err', err)
      })
    },
    timeStampFormatter (row, col, cell) {
      return cell === '' ? '' : this.$xcUtils.timestamp2Date(parseInt(cell))
    },
    gradeStr (grade) {
      // return  this.dict_grade.
      return grade ? this.dict_grade.find(item => item.dictCode === grade).dictLabel : '--'
    }
  }
}
</script>

<style lang="less" scoped>
::v-deep .el-descriptions-item__label.is-bordered-label {
  background-color: #F0F8FF !important;
  color: #606266 !important;
  font-size: 12px !important;
  font-weight: bold;
  width: 140px;
}
::v-deep .el-descriptions__title{
  font-weight: normal;
  display: flex;
  align-items: center;
}
::v-deep .el-descriptions__title::before{
  display: block;
  content: '';
  width: 3px;
  height: 18px;
  border-radius: 3px;
  background-color: #409EFF;
  margin-right: 6px;
}
.flex{
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}
</style>
